
# rewind

It all started in August of last year (2017) during a East coast road trip in the two weeks between summer and fall semesters.

### destinations:

ATL ➡️  
Waxhaw, NC ➡️  
Columbia, MD ➡️  
Millstone, NJ ➡️  
Northville, NY ➡️  
Millstone, NJ ➡️  
Tribeca, NY, NY  

Crazy trip all in all but the fun did not truly begin until I stepped foot in this marvelous "new" city taking the NJ Transit express train in from the Princeton Junction stop. Easy ride and only took around an hour. Got off at the end of the line Penn Station and then popped on over to the 1 or the ACE train downtown to Canal St area and then over a couple blocks to teensy little Tribeca Park near Beach St.

Phew... What a trip, but having lived in Barcelona for a little over year and a half total now I know how to pop in to a city and take it like a crash course in some crazy physics.

That weekend I hit up Chelsea, Meat Packing, Lower East Side, East Village and very briefly Grand Central and Central Park.

<br />
<a href="https://unsplash.com/photos/yUJfcGrJDbc" target="\_blank">
	<img src="/assets-cdbattaglia/media/blog-posts/frank-kohntopp-130291.webp" style={{width: "95%", height: "95%", display: "block", margin: "auto"}} />
</a>
<br />

# present day

As for January 2018, I have officially accepted a full time position with [InRhythm](https://www.inrhythm.com/) and today's my first day down here in FiDi by the big orange block on Broadway.

### my transition to NYC went like this:

- verbal job offer morning of January 12th and told expect offer letter by end of day
- lots of waiting and business end of day came and went and got offer letter at 9:51 PM
- look over offer letter Saturday morning with Faja Battaglia and everything checks out
- head to Target for lidded container boxes to put in bed of truck
- dinner with parents to say goodbye and celebrate Cindy Battaglia's (Momma) bday at Frankie's Italian
- wake up 5am Sunday morning to pack and get everything going
- car all packed by 2:30pm Sunday afternoon
- say goodbye to parents
- drive 5 hrs to Waxhaw, NC to sleep at Uncle and Aunt's place
- wake 6:00 AM Monday morning January 15th to head to McLean, VA driving 6 or so hours by lunch to meet my good buddy from Maryland Alec
- hour catch up conversation about life updates and rest my ass from the drive
- drive another 3 or so hours to get to Millstone, NJ by dinner time around 6:00 PM
- ravioli and hang out time with the extended fam (my 4 boy cousins)
- wake 8:00 AM Tuesday morning January 16th and train from Princeton Junction (just like back in August)
- meet Dayna from Brooklyn and two ladies taking a day in the city
- arrive around 10:30 AM and subway down to Canal St and Tribeca
- greeted by the cleaning lady at my cousin's apartment who doesn't necessarily have good English
- change into work attire and head to office in FiDi
- holy shit, am I New Yorker now?

Wowzers...

Now it's time to place all my friends from the city, figure out all the neighborhoods and set up camp.

### so far my knowledge is:

- Houston (don't pronounce like the place in Texas) divides uptown from downtown
- Broadway is a good middle divider East and West
- numbers increasing means you're heading uptown and vice versa
- each numbered st has an east side and west side (always use these when giving directions)
- each block in the city has 4 corners so when giving directions best to use the NW, NE, SE, SW directionals for spots (0: NW, 1: NE, 2: SE, 3: SW)
- metro lines I know so far:
	- ACE (kinda similar to the 1)
	- 1 (take this one up and downtown on the West side)
	- J (like a little L shape and goes out to East side around Alphabet city
- metro stops I know so far
	- Canal St
	- Fulton
	- 42nd and Times Square
- spots
	- FiDi (lower Manhattan pretty far south)
		- Freedom Tower
		- World Trade
		- Big Orange Block
		- Wall St
		- Bull
	- Tribeca (north of FiDi in middle kinda around Broadway)
		- Tribeca park triangle
	- Lower East (to East of FiDi and Tribeca)
		- also known as LES
	- Lower West
		- Meat Packing
		- Chelsea
	- Alphabet City (between LES and East Village)
	- East Village
	- Murray Hill
	- Kips Bay
	- West Side of Central Park is Upper West Side
	- East Side of Central Park is Upper East Side
	- Far North is Harlem and then the Bronx
	- Far South and across bridge is Brooklyn
	- Brooklyn
		- DUMBO = "Down Under the Manhattan Bridge Overpass"

And this so far after two trips and a grand total of a week is about all I know for the great city of New York, New York.

Til the next post!

Ta ta for now!

Best,
Christian
